export const SPECTATORS_PAGE_SIZE = 50;
